import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { initErrorReporter } from "./lib/errorReporter";

// Initialize error reporter
initErrorReporter({
  release: import.meta.env.VITE_APP_VERSION || new Date().toISOString().split('T')[0],
  environment: import.meta.env.MODE,
});

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
